<template>
  <div>
    <div v-show="done">
      <div v-if="user.is_system">
        <h4>
          {{ "sold_total" | setText("Итого продано") }}
          <span v-if="shop">- {{ shop.name }}</span>
        </h4>
        <div class="row no-gutters">
          <div
            class="col-md-6 col-lg-4 col-xl-3"
            v-for="stat in transactions"
            :key="stat.title"
          >
            <stats-card>
              <div
                class="numbers-icon"
                :class="`icon-${stat.type}`"
                slot="header"
              >
                <img src="/images/features/appointment.svg" />
              </div>
              <div class="numbers-text" slot="content" :title="stat.key">
                <h4>{{ stat.key | setText(stat.title) }}</h4>
                <p>{{ stat.value | spaceBetweenNumber }} UZS</p>
              </div>
            </stats-card>
          </div>
        </div>
      </div>
      <div v-if="user.is_system">
        <h4>{{ "stat_total" | setText("Общая статистика") }}</h4>
        <div class="row no-gutters">
          <div
            class="col-md-6 col-lg-4 col-xl-3"
            v-for="stat in stats"
            :key="stat.title"
          >
            <stats-card>
              <div
                class="numbers-icon"
                :class="`icon-${stat.type}`"
                slot="header"
              >
                <img :src="`/images/features/${stat.img}`" />
              </div>
              <div class="numbers-text" slot="content">
                {{ stat.value | spaceBetweenNumber }}
                <p>{{ stat.key | setText(stat.title) }}</p>
              </div>
            </stats-card>
          </div>
        </div>
      </div>
      <div class="ratings" v-if="user.is_system || shop">
        <!-- <orders-simple /> -->
        <h4>
          TOP 10 <span v-if="shop">- {{ shop.name }}</span>
        </h4>
        <div class="row no-gutters">
          <div
            class="col-md-6 col-lg-4 col-xl-3"
            v-for="(stat, k) in users"
            :key="k"
          >
            <card>
              <h5 class="mb-1">{{ stat.key | setText(stat.title) }}</h5>
              <ul class="">
                <li v-for="(u, k) in stat.value" :key="k">
                  <span> {{ k + 1 }}. {{ u.name }} </span>
                  <span> {{ u.sales | spaceBetweenNumber }} UZS</span>
                </li>
              </ul>
            </card>
          </div>
        </div>
      </div>
      <div v-else>
        <h4>
          {{ "welcome" | setText("Добро пожаловать") }},
          {{ $store.state.user.name }}!
        </h4>
        <p>{{ "set_now" | setText("В меню навигации выберите раздел") }}</p>
      </div>
    </div>
  </div>
</template>
<script>
import { StatsCard, ChartCard } from "@/components/index";
import { errorNotify } from "@/plugins/functions";
import Chartist from "chartist";
import OrdersSimple from "./OrdersSimple";
import { mapState } from "vuex";
export default {
  components: {
    StatsCard,
    ChartCard,
  },
  created() {
    // if (this.user) {
    //   this.first_name = this.user.first_name;
    //   this.last_name = this.user.last_name;
    // }
    if (this.user["is_root"] || this.shop) {
      this.refresh();
    }
  },
  methods: {
    refresh() {
      this.done = false;
      this.$loading(true);
      this.$http
        .get(`stats`)
        .then((response) => {
          this.stats = response.data.stats;
          this.transactions = response.data.transactions;
          this.date = response.data.time;
          this.users = response.data.users;
        })
        .catch((error) => {
          errorNotify(error, this.$notify);
        })
        .finally(() => {
          this.done = true;
          setTimeout(() => {
            this.$loading(false);
          }, 200);
        });
    },
  },
  data() {
    return {
      done: false,
      stats: [],
      users: [],
      transactions: [],
      date: null,
      first_name: "",
      last_name: "",
      password: "",
      password_confirmation: "",
    };
  },
  computed: {
    ...mapState(["user", "lastUpdate", "shop"]),
  },
  watch: {
    lastUpdate(val) {
      this.refresh();
    },
  },
};
</script>

<style lang="scss">
.ratings {
  & h5 {
    color: #2c75ff;
    font-weight: 600;
    font-size: 1.4em;
    min-height: 40px;
  }
  & ul {
    & > li {
      padding: 6px 0;
      // display: flex;
      & > span {
        line-height: 18px;
        font-size: 14px;
        display: block;

        &:first-child {
          font-weight: 500;
          margin-bottom: 1px;
        }

        &:last-child {
          color: #e61d73;
        }
      }
    }
  }
}
</style>
